var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38451 1.68527L1.44489 11.5331C1.13532 12.0463 1.5147 12.6667 2.06038 12.6667H13.9396C14.4853 12.6667 14.8647 12.0463 14.5551 11.5331L8.61549 1.68527C8.33246 1.21602 7.66754 1.21602 7.38451 1.68527ZM0.303155 10.8444L6.24277 0.996641C7.04426 -0.332214 8.95574 -0.332214 9.75723 0.996641L15.6968 10.8444C16.5313 12.2279 15.5445 14 13.9396 14H2.06038C0.455501 14 -0.531298 12.2279 0.303155 10.8444ZM8 4.66667C8.36819 4.66667 8.66667 4.96514 8.66667 5.33333V8C8.66667 8.36819 8.36819 8.66667 8 8.66667C7.63181 8.66667 7.33333 8.36819 7.33333 8V5.33333C7.33333 4.96514 7.63181 4.66667 8 4.66667ZM8 10C7.63181 10 7.33333 10.2985 7.33333 10.6667C7.33333 11.0349 7.63181 11.3333 8 11.3333H8.00667C8.37486 11.3333 8.67333 11.0349 8.67333 10.6667C8.67333 10.2985 8.37486 10 8.00667 10H8Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d438642d.svg";
export { ForwardRef as ReactComponent };